import { categories } from '@/mocks/categories';
import { featuredImages } from '@/mocks/images';

const imageMap: Record<string, string> = {
  'Shoes': featuredImages.shoes,
  'Hoodies/Sweaters': featuredImages.hoodies,
  'T-Shirts': featuredImages.tshirts,
  'Jackets': featuredImages.jackets,
  'Pants/Shorts': featuredImages.pants,
  'Headwear': featuredImages.headwear,
  'Sets': featuredImages.sets,
  'Underwear/Underpants': featuredImages.underwear,
  'Jersey': featuredImages.jersey,
  'Accessories': featuredImages.accessories,
  'Bags': featuredImages.bags,
  'Belts': featuredImages.belts,
  'Perfumes': featuredImages.perfumes,
  'Other Stuff': featuredImages.other,
};

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/70 mb-5">
            <span className="text-xs font-medium text-secondary-700 tracking-wide">All Categories</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Explore Every Sugargoo Spreadsheet Category
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            Click any category to browse our complete Sugargoo spreadsheet database for that product type.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-32 md:h-36 overflow-hidden">
                <img
                  src={imageMap[cat.name] || featuredImages.other}
                  alt={`Sugargoo spreadsheet ${cat.displayName} category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="p-3">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap truncate">
                    {cat.displayName}
                  </span>
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100/60 group-hover:bg-primary-500 transition-colors flex-shrink-0 ml-2">
                    <i className="ri-arrow-right-up-line text-xs text-primary-600 group-hover:text-background-50 transition-colors"></i>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}